<style scoped>
.mt5{
	margin-top: 5px;
}
.mt-22{
	margin-top: -22px!important;
}
@media screen and (min-width:1900px){
	.mediaWidth{
	    width: 25%;
	}
	.mediaInput{
		width:50%;
		margin-top: -20px!important;
	}
	.selpar_r{
        padding-right: 35px!important;
        padding-left: 0px!important;
    }
    .mediapar{
        margin-left: 0!important;
        padding-right: 0px!important;
    }
    .selpar_l{
        padding-right: 40px!important;
    }
    .medl{
        padding-right: 75px!important;
    }
    .medr{
        padding-right: 75px!important;
    }
}
@media screen and (min-width:1450px) and (max-width:1900px){
	.mediaWidth{
	    width: 33%;
	}
	.mediaInput{
		width:50%;
		margin-top: -5px!important;
	}
}
@media screen and (min-width:995px) and (max-width:1450px){
	.mediaWidth{
	    width: 50%;
	}
	.mediaInput{
		width:50%;
		margin-top: 0px!important;
	}
	.form-group{
		margin-bottom: 0;
	}
	.selpar_r{
	    padding-right: 75px!important;
	    padding-left: 0px!important;
	}
	.mediapar{
	    margin-left: 0!important;
	}
	.selpar_l{
	    padding-right: 45px!important;
	}
}
@media screen and (max-width:992px){
	.mediaInput{
		margin-top: -25px!important;
	}
	.form-group{
		margin-bottom: 5px!important;
	}
	.medl{
		padding-left: 15px!important;
		padding-right: 15px!important;
	}
	.medr{
		padding-left: 15px!important;
		padding-right: 75px!important;
	}
}
</style>
<template>
	<div class="panel panel-default print-display">
		<div class="panel-body pl0">
			<div class="tie-4">
				<div class="tie-f ptb4"><span class="cae bk bk-green mt5">筛选</span></div>
				<div class="tie-s pl15">
					<div><slot name="s8"></slot></div>
					<form class="form-horizontal row">
						<div class="form-group col-lg-3 col-md-6 ml15 mediaWidth"><slot name="s1"></slot></div>
						<div class="form-group col-lg-3 col-md-6 mediaWidth"><slot name="s2"></slot></div>
						<div class="form-group col-lg-3 col-md-6 ml15 mediaWidth"><slot name="s3"></slot></div>
						<div class="form-group col-lg-3 col-md-6 mediaWidth"><slot name="s4"></slot></div>
						<div class="form-group col-lg-3 col-md-6 ml15 mediaWidth"><slot name="s5"></slot></div>
						<div class="form-group col-lg-3 col-md-6 mediaWidth"><slot name="s6"></slot></div>
						<div class="form-group col-lg-3 col-md-6 ml15 mediaWidth"><slot name="s66"></slot></div>
						<div class="form-group col-lg-4 mediaInput"><slot name="s7"></slot></div>
						<div class="form-group"><slot name="chosen"></slot></div>
					</form>
				</div>
				<div class="form-hr"></div>
				<div class="tc">
					<button class="btn btn-md btn-primary plr20 mt10" @click="submit">搜索</button>
					<slot name="s9"></slot>
               	</div>
			</div>
		</div>
</template>
<script>
	var Http = require('../utils/HttpHelper.js');
	/**
	* 组件对象
	*/
	var Component = {
		methods: {
			submit: function() {
				this.$dispatch('submit');//分发传递
			}
		}
	};
	module.exports = Component;
</script>


/** WEBPACK FOOTER **
 ** Search.vue?a14a6990
 **/